module.exports = __webpack_public_path__ + "img/img-live-fb.3e83afb1.png";